<!--H5引导打开APP-->
<template>
  <div v-if="!isHarmony" class="open-app-container">
    <div class="to_app" @click="openLinkApp">
      <img src="https://files.wondercv.com/openApp/open_app_logo.png" alt="">
      <div class="open">打开APP</div>
    </div>
    <div class="open-app" @click="openLinkApp" v-if="smallBtn">
      APP 内打开
    </div>
  </div>
</template>

<script>
import { envMixin } from '../../assets/js/mixin/global';
export default {
  name: "open-app",
  mixins: [envMixin],
  props: {
    // 是否显示固定定位下的小按钮
    smallBtn: {
      type: Boolean,
      default: false
    },
    needReload: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    openLinkApp() {
      this.$emit("openLinkApp", this.needReload)
    }
  }
}
</script>

<style lang="scss" scoped>
.open-app {
  width: 94px;
  height: 30px;
  background: #FF6644;
  box-shadow: 0px 0px 10px 0px rgba(64, 64, 64, 0.24);
  border-radius: 15px;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 60px;
  z-index: 999;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  line-height: 30px;
}
.to_app {
  width: 100%;
  height: 56px;
  padding: 0 24px;
  position: fixed;
  left: 0;
  top: 0px;
  //margin-top: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f9f9f9;
  z-index: 99;

  img {
    width: 145px;
    height: 36px;
  }

  .open {
    width: 77px;
    height: 28px;
    border-radius: 14px;
    background-color: #ff6644;
    color: #fff;
    font-size: 12px;
    line-height: 28px;
    text-align: center;
  }
}
</style>